/**
 * List of public routes that don't require authentication
 * These routes will not trigger the bootstrap authentication flow
 */
export const PUBLIC_ROUTES = ['/signup', '/login-studio', '/login-artist', '/error'];

/**
 * Check if a given pathname is a public route
 * @param {string} pathname - The pathname to check
 * @returns {boolean} - True if the pathname is a public route
 */
export const isPublicRoute = (pathname) => {
    return PUBLIC_ROUTES.some(path => pathname.startsWith(path));
};

